// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./css/snippet_featured_small.css
// module id = 87
// module chunks = 0